import { PermissionsEnum } from '@/auth/interfaces';
import { useCheckPermissions } from '@/shared';
import { SaveOLTComponent } from '../../shared/components/SaveOLTComponent';

export interface CreateOltPageProps {}

const CreateOltPage: React.FC<CreateOltPageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_add_olt);

  return <SaveOLTComponent title="Crear OLT" />;
};

export default CreateOltPage;
